import React from 'react';

import {Box, Button, CardMedia, Stack, Typography} from '@mui/material';
import Icon from 'presentation/icons';
import {translations} from 'presentation/translations-new';
import {useAppointmentAddress} from './hooks/useAppointmentAddress';
import {AppointmentAddressProps} from './types';

const {address: addressTitle} = translations['pt-br'].commons;
const {openMap} = translations['pt-br'].privateFlow.bookingFlow.unitsFlow.unitDetails;

export function AppointmentAddress({
	addressForMaps,
	formattedAddress,
	handleOpenMap,
	hideButton,
	hideMap,
}: AppointmentAddressProps) {
	const {hideMapComponent, mapsImage, theme, isMobile, mapSrc} = useAppointmentAddress({
		addressForMaps: addressForMaps || '',
		hideMap,
	});

	return (
		<Stack gap={'10px'}>
			<Typography variant="subheader">{addressTitle}</Typography>
			<Stack gap={1} direction="row">
				<Icon name="location-default" size={24} color={theme.palette.primary.main} />
				<Typography variant="body2" color="text.primary">
					{formattedAddress}
				</Typography>
			</Stack>

			{hideMapComponent ? (
				<CardMedia
					component="img"
					image={mapsImage}
					alt={'Endereço da unidade'}
					onClick={handleOpenMap}
					sx={{cursor: 'pointer'}}
				/>
			) : (
				<iframe
					width="100%"
					height="150"
					style={{border: 0}}
					loading="lazy"
					title="Mapa da unidade"
					referrerPolicy="no-referrer-when-downgrade"
					src={mapSrc}
				/>
			)}

			{hideButton ? null : (
				<Box>
					<Button
						onClick={handleOpenMap}
						fullWidth={isMobile}
						variant="outlined"
						endIcon={<Icon name="map" />}>
						{openMap}
					</Button>
				</Box>
			)}
		</Stack>
	);
}
